export const COLOR_STATUS = {
  ZERO_MISTAKES: 'rgb(128, 216, 255)',
  HAS_PASSED: 'rgb(174, 213, 129)',
  HAS_NOT_CAME: 'rgb(255, 238, 88)',
  NOT_HAS_PASSED: 'rgb(174, 213, 129)'
}

export const RESULT_TYPES = {
  AFWEZIG: 'Afwezig',
  VOLDOENDE: 'Voldoende',
  ONVOLDOENDE: 'Onvoldoende'
}

export const CBR_TYPES = {
  TOP: 'TOP',
  MIJN: 'MIJN'
}

export const PURPLE = '#8A0E67'

export const RESULT_FILTERS = 'result_filters'